import MultiSelectQuestion from './container'
export default MultiSelectQuestion
